// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"31dbc7be","453":"0825c7a1","595":"829b7788","686":"8097a844","999":"49a00762"}[chunkId] + ".chunk.js";
};